

export const storeManageListNewData = [
  {
    id: 'baseInfo',
    title: '',
    data: [
      {
        id: 'storeName',
        name: '决策机构形式(2分)',
        placeholder: '',
        type: 'input',
        checkType: 'required',
        newDisabled: false,
        editDisabled: false,
        newShow: true,
        editShow: true,
        value: '',
        options: [],
        expand: {},
        jpath: 'storeName'
      },
    ]
  }
];
